export default "__VITE_ASSET__hyf0rA_g__"